import { centerable as l } from "../decorators/centerable.js";
import { uploadable as i } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import { defineAttrs as s } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const a = s({
  type: { default: "videoFile" },
  duration: { default: 0 },
  url: { default: "" },
  thumbnailUrl: { default: "" },
  captions: { default: "" }
}), d = l(
  i({
    inline: !1,
    draggable: !0,
    attrs: a,
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-video-file",
        getAttrs(e) {
          const t = e.querySelector("a"), r = e.querySelector("img");
          return {
            thumbnailUrl: (r == null ? void 0 : r.getAttribute("src")) ?? "",
            url: (t == null ? void 0 : t.getAttribute("href")) ?? "",
            captions: (r == null ? void 0 : r.getAttribute("alt")) ?? ""
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-video video",
        getAttrs(e) {
          const t = e.querySelector("source");
          return {
            thumbnailUrl: e.getAttribute("poster") ?? "",
            url: (t == null ? void 0 : t.getAttribute("src")) ?? "",
            captions: (t == null ? void 0 : t.getAttribute("alt")) ?? ""
          };
        }
      }
    ],
    toDOM(e) {
      const t = e.attrs;
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.video}`
        },
        [
          "video",
          {
            class: "block-video-file-player",
            controls: "pause play mute",
            poster: t.thumbnailUrl,
            style: "display: block; width: 100%; height: 100%;"
          },
          [
            "source",
            {
              src: t.url,
              alt: t.captions
            }
          ]
        ]
      ];
    }
  })
);
export {
  d as videoFileSpec
};
